import { render, staticRenderFns } from "./AccountPanelHeading.vue?vue&type=template&id=97beadee&lang=pug&"
import script from "./AccountPanelHeading.vue?vue&type=script&lang=js&"
export * from "./AccountPanelHeading.vue?vue&type=script&lang=js&"
import style0 from "./AccountPanelHeading.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports